import {
	AddPriceGroupMutation,
	AdjustPriceLevelsMutation,
	BatchActivatePriceGroupsMutation,
	BatchDeletePriceGroupsMutation,
	BatchInactivatePriceGroupsMutation,
	DeletePriceGroupMutation,
	DeletePriceLevelMutation,
	DeletePriceLevelsMutation,
	MergePriceLevelMutation,
	SetDefaultGroupMutation,
	SetPriceGroupDerivationMutation,
	SetPriceGroupOrderVolumeDiscountMutation,
	SetPriceGroupQualificationConditionsMutation,
	SetPriceLevelsVolumePoolMutation,
	UpdatePriceGroupMutation,
	UpdatePriceLevelsMutation
} from "~/gql/mutations/price.generated";
import { CreateVolumePoolMutation, ReactivateVolumePoolMutation } from "~/gql/mutations/volumePools.generated";
import {
	GetCategoryVolumeCoverageQuery,
	GetItemPriceExplanationQuery,
	GetItemPriceLevelsQuery,
	GetItemPriceQuery,
	GetOrderLinePricePreviewQuery,
	GetPriceGroupMetaQuery,
	GetPriceGroupQuery,
	GetPriceGroupsQuery
} from "~/gql/queries/price.generated";
import { GetPriceGroupUsedByQuery } from "~/gql/queries/usedBy.generated";
import { GetVolumePoolsQuery } from "~/gql/queries/volumePools.generated";

const invalidatePrice: NonNullable<AddTagTypes> = ["Price", "PortalPrice"];

export const priceEndpoints = {
	AddPriceGroup: {
		invalidatesTags: [...invalidatePrice, "Learning"] as AddTagTypes,
		transformResponse: (res: AddPriceGroupMutation) => res
	},
	AdjustPriceLevels: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: AdjustPriceLevelsMutation) => res
	},
	BatchActivatePriceGroups: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: BatchActivatePriceGroupsMutation) => res
	},
	BatchDeletePriceGroups: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: BatchDeletePriceGroupsMutation) => res
	},
	BatchInactivatePriceGroups: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: BatchInactivatePriceGroupsMutation) => res
	},
	CreateVolumePool: {
		invalidatesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: CreateVolumePoolMutation) => res
	},
	DeletePriceGroup: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: DeletePriceGroupMutation) => res
	},
	DeletePriceLevel: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: DeletePriceLevelMutation) => res
	},
	DeletePriceLevels: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: DeletePriceLevelsMutation) => res
	},
	GetPriceGroupUsedBy: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetPriceGroupUsedByQuery) => res
	},
	GetCategoryVolumeCoverage: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetCategoryVolumeCoverageQuery) => res
	},
	GetItemPrice: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetItemPriceQuery) => res
	},
	GetItemPriceExplanation: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetItemPriceExplanationQuery) => res
	},
	GetItemPriceLevels: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetItemPriceLevelsQuery) => res
	},
	GetOrderLinePricePreview: {
		transformResponse: (res: GetOrderLinePricePreviewQuery) => res
	},
	GetPriceGroup: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetPriceGroupQuery) => res
	},
	GetPriceGroupMeta: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetPriceGroupMetaQuery) => res
	},
	GetPriceGroups: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetPriceGroupsQuery) => res
	},
	GetVolumePools: {
		providesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: GetVolumePoolsQuery) => res
	},
	MergePriceLevel: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: MergePriceLevelMutation) => res
	},
	ReactivateVolumePool: {
		invalidatesTags: ["Price"] as AddTagTypes,
		transformResponse: (res: ReactivateVolumePoolMutation) => res
	},
	SetDefaultGroup: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: SetDefaultGroupMutation) => res
	},
	SetPriceGroupDerivation: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: SetPriceGroupDerivationMutation) => res
	},
	SetPriceGroupOrderVolumeDiscount: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: SetPriceGroupOrderVolumeDiscountMutation) => res
	},
	SetPriceGroupQualificationConditions: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: SetPriceGroupQualificationConditionsMutation) => res
	},
	SetPriceLevelsVolumePool: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: SetPriceLevelsVolumePoolMutation) => res
	},
	UpdatePriceGroup: {
		invalidatesTags: invalidatePrice,
		transformResponse: (res: UpdatePriceGroupMutation) => res
	},
	UpdatePriceLevels: {
		invalidatesTags: ["Price", "PortalCatalog", "PortalPrice"] as AddTagTypes,
		transformResponse: (res: UpdatePriceLevelsMutation) => res
	}
};
